exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".warning{color:#ff4500}.success{color:green}.error{color:red}.tableheaderStyling{background-color:#002b49;color:#fff;font-weight:unset;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c026c1ba","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/expense/singleExpenseDetails.vue
// module id = 1794
// module chunks = 0